export function buildTitleFromFilename(filename = '', maxLength = 60) {
  const nameWithoutExt = filename.includes('.')
    ? filename.split('.').slice(0, -1).join('.')
    : filename;
  const cleaned = (nameWithoutExt || filename || 'Uploaded asset')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const capitalized = cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : 'Uploaded asset';
  if (capitalized.length <= maxLength) return capitalized;
  return `${capitalized.slice(0, maxLength - 1)}…`;
}
